import { UserRequiresPhoneVerificationResultAjax } from './user-requires-phone-verification.backend-model';
import { UserRequiresPhoneVerification } from './user-requires-phone-verification.model';

export function transformUserRequiresPhoneVerification(
  userRequiresPhoneVerificationResultAjax: UserRequiresPhoneVerificationResultAjax,
  authUid: string,
): UserRequiresPhoneVerification {
  return {
    id: authUid,
    userRequiresPhoneVerification:
      userRequiresPhoneVerificationResultAjax.userRequiresPhoneVerification,
  };
}
